import { VueConstructor as _Vue, PluginObject } from 'vue';
import { IUserGuiding } from './types';

export class UserGuidingPlugin implements IUserGuiding {
  public APP_WINDOW: any = window;
  public APP_DOCUMENT: any = document;

  constructor(private userGuidingId?: string, private _options?: any) {
    //
  }

  static getScript(trackId: string) {
    return `(function(g,u,i,d,e,s){g[e]=g[e]||[];var f=u.getElementsByTagName(i)[0];var k=u.createElement(i);k.async=true;k.src='https://static.userguiding.com/media/user-guiding-'+s+'-embedded.js';f.parentNode.insertBefore(k,f);if(g[d])return;var ug=g[d]={q:[]};ug.c=function(n){return function(){ug.q.push([n,arguments])};};var m=['previewGuide','finishPreview','track','triggerNps','hideChecklist','launchChecklist'];for(var j=0;j<m.length;j+=1){ug[m[j]]=ug.c(m[j]);}})(window,document,'script','userGuiding','userGuidingLayer','${trackId}');`;
  }

  load() {
    return new Promise((res: any, rej: Function) => {
      if (!this.userGuidingId) {
        rej('No user guiding Id provided');
      }
      let id = 'userguiding-lib';
      if (this.APP_DOCUMENT.getElementById(id) || this.APP_WINDOW.userGuiding)
        return;
      let script = this.APP_DOCUMENT.createElement('script');
      script.async = true;
      script.type = 'text/javascript';
      script.innerHTML = this.userGuidingId
        ? UserGuidingPlugin.getScript(this.userGuidingId)
        : null;
      script.id = id;
      this.APP_DOCUMENT.head.appendChild(script);
      setTimeout(() => res(true), 4000);
    });
  }

  setIdentificationToken(id: string | null, properties: object = {}) {
    if (this.APP_WINDOW?.userGuiding?.identify) {
      this.APP_WINDOW.userGuiding?.identify(id, properties);
    }
  }

  destroy() {
    this.APP_WINDOW.userGuiding.destroy();
  }
}

export const UserGuidingInstance: PluginObject<any> = {
  install: (VueInstance: _Vue, options: any) => {
    VueInstance.prototype.$UserGuiding = new UserGuidingPlugin(
      options.userGuidingId,
      {}
    );
  }
};
